export default "__VITE_ASSET__BxEGLRTz__"